import React from 'react'
import Navbar from '../components/Navbar'
import { Outlet, useLocation } from 'react-router-dom'
import Footer from '../components/Footer'
import MobileBottomBar from '../components/MobileBottomBar'

const PublicLayout = () => {
    const location = useLocation();
    const isSearchPage = location.pathname === "/search";

    return (
        <div className={!isSearchPage ? "pb-5 mb-5 pb-md-0 mb-md-0" : ""}>
            <Navbar />
            <Outlet />
            <Footer />
            <MobileBottomBar/>
        </div>
    )
}

export default PublicLayout